import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { TikTokConfigurationPage } from './tiktok/TikTokConfigurationPage';
import { MiraklConfigurationPage } from './mirakl/MiraklConfigurationPage';

import { CHANNELS } from '../../constants/channels';

export function RetailerIntegrationConfigurationPage({ type }) {
  switch (type) {
    case CHANNELS.TIKTOK:
      return <TikTokConfigurationPage />;

    case CHANNELS.MIRAKL:
      return <MiraklConfigurationPage />;

    default:
      return <Redirect to="/" />;
  }
}

RetailerIntegrationConfigurationPage.propTypes = {
  type: PropTypes.string.isRequired,
};
